/**
 * Layout route that keeps launcher-only users (the Leadership Team) on the
 * Launches page. Every route except ``/launches`` sits under it; a
 * launcher-only user who lands anywhere else is redirected there.
 *
 * UX only, like ``AdminGate``: the API 403s a launcher-only caller on every
 * route but ``/api/me`` and ``/api/launches``. Holding the page while
 * ``/api/me`` loads is what stops a launcher-only user from seeing a flash of
 * a page whose data calls would all 403.
 */
import { Navigate, Outlet } from "react-router-dom";
import { useMe } from "@/auth/useMe";

export function MemberGate() {
  const { data, isLoading } = useMe();

  if (isLoading) {
    return (
      <p className="font-sans text-sm text-bw-ink-muted">Checking permissions…</p>
    );
  }
  if (data?.launcher_only) {
    return <Navigate to="/launches" replace />;
  }
  return <Outlet />;
}
